export default {
    appLogin({}, payload) {
        const { fullName, token } = payload
        localStorage.setItem('dtp_loggedUser', fullName)
        localStorage.setItem('dtp_token', token)
    },
    appLogout() {
        localStorage.removeItem('dtp_loggedUser')
        localStorage.removeItem('dtp_token')
    },
    updateProfile({}, payload) {
        const { fullName } = payload
        localStorage.setItem('dtp_loggedUser', fullName)
    },
    appLoading({ commit }, isLoading) {
        commit('setLoading', isLoading);
    }
}